import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { registerPush, isPushActive } from "@/lib/push";

export function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const lastSeen = useRef(null);
  useEffect(() => { isPushActive().then((a) => a && registerPush().catch(() => {})); }, []);
  const load = async () => {
    try {
      const { data: d } = await api.get("/notifications");
      const newest = d.items[0];
      if (newest && lastSeen.current && newest.id !== lastSeen.current && !newest.read && "Notification" in window && Notification.permission === "granted") {
        new Notification(newest.title, { body: newest.body });
      }
      if (newest) lastSeen.current = newest.id;
      setData(d);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);
  const toggle = async () => {
    if ("Notification" in window && Notification.permission === "default") registerPush().catch(() => {});
    setOpen((o) => !o);
    if (!open && data.unread > 0) { await api.post("/notifications/read-all"); setData((d) => ({ ...d, unread: 0, items: d.items.map((i) => ({ ...i, read: true })) })); }
  };
  return (
    <div className="relative">
      <button data-testid="notifications-bell" onClick={toggle} className="h-9 w-9 rounded-lg bg-secondary flex items-center justify-center text-foreground relative">
        <Bell size={18} />
        {data.unread > 0 && <span data-testid="notifications-count" className="absolute -top-1 -right-1 h-5 min-w-[20px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center">{data.unread}</span>}
      </button>
      {open && (
        <div data-testid="notifications-panel" className="absolute right-0 mt-2 w-80 max-h-96 overflow-auto neon-card p-2 z-50 shadow-2xl">
          {data.items.length === 0 && <div className="p-3 text-sm text-muted-foreground">Sin notificaciones.</div>}
          {data.items.map((n) => (
            <Link key={n.id} to={n.link || "/"} onClick={() => setOpen(false)} className={`block rounded-lg p-2.5 text-sm hover:bg-secondary/60 ${!n.read ? "bg-primary/10" : ""}`}>
              <div className="font-semibold">{n.title}</div><div className="text-xs text-muted-foreground">{n.body}</div><div className="text-[10px] text-muted-foreground">{fmtDate(n.created_at)}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
